import * as THREE from "../../../../../libs/three.js/build/three.module.js";
import Particle from './Particle.js'
import Tween from '../Tween.js'
import { vertexShader, fragmentShader } from './shader.js'

const Type = Object.freeze({ "CUBE":1, "SPHERE":2 });
let particleTexture  

const getTexture = ()=>{
    if(!particleTexture){
        particleTexture = new THREE.TextureLoader().load( Potree.resourcePath+'/textures/smokeparticle.png')
    }
    return particleTexture
}
const boxGeo = new THREE.BoxBufferGeometry(1,1,1,1);
const boxMat = new THREE.MeshBasicMaterial({wireframe:true, color:"#ffffff"})




const defaults = 
{
    positions: [],
    positionStyle    : "sphere",
    positionBase     : new THREE.Vector3( 0, 0, 0 ),
 
    positionSpread   : new THREE.Vector3( 1, 1, 0), //cube
     
    radius   :   1,       // sphere
        
    velocityStyle    : 'cube',
     
    velocityBase     : new THREE.Vector3( 0,  0,  0.5),     // cube  基础速度
    velocitySpread   : new THREE.Vector3( 1, 1, 0.3), 
    
    accelerationBase : 0.3,             //基础加速度
    accelerationSpread : 0.6,	
    
    //没使用
    speedBase  : 0.1,       //sphere
    speedSpread : 0.5,
          
    

    angleBase               : 0,
    angleSpread             : 360,
    angleVelocityBase       : 1,
    angleVelocitySpread     : 30,
    angleAccelerationBase   : 1,
    angleAccelerationSpread : 5,
        
    sizeBase    :   0,  
    sizeSpread  :   0,
    sizeTween    : [[0, 0.3,   1], [0.3, 1.4,  6 ]], 
    
    
    colorBase   :   new THREE.Vector3(0.0, 1.0, 0.5), 
    colorSpread :   new THREE.Vector3(0.0, 0.0, 0.0),
    colorTween   : new Tween( [0.2, 1], [ new THREE.Vector3(0,0,0.4), new THREE.Vector3(0, 0, 0.1) ] ),

    opacityBase     :   0.1,//1.0,
    opacitySpread   :   0.2,
    opacityTween :[ [0, 0.1, 0.9, 1], [0.1, 0.4 , 0.03, 0 ] ], 
     
    //particlesPerSecond : 20,
    strength : 1,
    particleDeathAge   : 3,  //从底下升起后能持续的时间		
    //emitterDeathAge    : 60 // time (seconds) at which to stop creating particles.
    height : 3,
};


const debugSphere = new THREE.Mesh(new THREE.SphereBufferGeometry(0.03, 5,5), new THREE.MeshBasicMaterial({color:'white',depthTest:false}))

export default class SmokeParticle extends THREE.Points{
    constructor(prop={}) {
        super()
        
         
        this.blendStyle = THREE.NormalBlending; // false; 
        this.emitterAge = 0.0;
        //this.emitterAlive = true;
       
        prop = $.extend({}, defaults, prop)
        for ( var key in prop ){
            let value = prop[key] 
            if(value instanceof Array && value[0] instanceof Array ) this[ key ] = new Tween(...value)
            else if(value instanceof THREE.Vector3 || value instanceof THREE.Color){
                this[ key ] = value.clone()
            }else{
                this[ key ] = value
            }
        }
        
        this.defaultSizeTween = this.sizeTween.clone()
        this.defaultOpacityTween = this.opacityTween.clone()
        
        
        this.geometry = new THREE.BufferGeometry()
        this.computeParams()
        this.createMaterial()
        this.createGeometry()
        
        this.dynamic = true;
        this.sortParticles = true; 
        this.frustumCulled = false//似乎是禁止相机裁剪，否则会在某些角度消失。但是会不会更耗性能呢？
       
        prop.position && this.position.copy(prop.position)
        
        
        
        
        //---------------------------------------
        this.setSize({viewport:viewer.mainViewport})
        this.setFov(viewer.fov)
        
        let setSize = (e)=>{
            if(e.viewport.name != "MainView")return
            this.setSize(e)
        }
        let setFov = (e)=>{
            this.setFov(e.fov) 
        }
        /* let reStart = (e)=>{
            if(e.v){//重新一个个放出粒子，否则会一股脑儿全部出来，因为同时大于粒子周期了一起重新生成出现。
                setTimeout(()=>{//会先update一次delta为pageUnvisile的时间才触发 
                    //console.log('归零') 
                    //this.reStart()
                },1) 
            } 
        } */
        viewer.addEventListener('resize',setSize) 
        viewer.addEventListener('fov_changed',setFov)
        //viewer.addEventListener('pageVisible', reStart)
        
        this.addEventListener('dispose',()=>{
            viewer.removeEventListener('resize',setSize) 
            viewer.removeEventListener('fov_changed',setFov)
            //viewer.removeEventListener('pageVisible', reStart)
        })   
        
    }
    
    
    
    computeParams(){   
         
        let length = (this.curve ? this.curve.wholeLength : 0) + this.radius * 2 //加上首尾的半径
        //注意：烟最低高度一米, 0<strength<1
        if(this.positionStyle == 'cube'){
            this.positionSpread.set(this.radius,this.radius,0)
        } 
        this.velocityBase.set(0,0, (this.height - 0.5 * this.accelerationBase * this.particleDeathAge * this.particleDeathAge) / this.particleDeathAge )
        //let height = this.velocityBase.z * this.particleDeathAge + 0.5 * this.accelerationBase * this.particleDeathAge * this.particleDeathAge;//s = V0 * t + 0.5 * a * t*t ;     
        this.velocityBase.z = Math.max(0,this.velocityBase.z);
        this.particleCount =  Math.ceil(  length * Math.sqrt(this.strength * this.height * this.radius )   )  
        this.particleCount = Math.max(5,this.particleCount)
        { 
            const minSize = 1, maxSize = 2, minBound = 0.01, maxBound = 1;
            let size = minSize + (maxSize - minSize) * THREE.Math.smoothstep( this.strength, minBound, maxBound);
                
            this.sizeTween.values = this.defaultSizeTween.values.map(e=> e*size)
        }
        { 
            const minSize = 1 , maxSize = 1.5, minBound = 0.01, maxBound = 1;
            let opac = minSize + (maxSize - minSize) * THREE.Math.smoothstep( this.strength, minBound, maxBound);
                
            this.opacityTween.values = this.defaultOpacityTween.values.map(e=> e*opac )
        }
         
        //console.log('smoke  particleCount',this.particleCount)
        
        
        
        
    }

    reStart(){
        this.emitterAge = 0; 
        this.createGeometry()  
    }


    updateGeometry(){ 
        this.computeParams()
        this.reStart() 
        
    }
    
    
    createParticle(center)
    {
        var particle = new Particle({
            sizeTween : this.sizeTween,
            opacityTween : this.opacityTween,
            colorTween : this.colorTween,
        });
        particle.deathAge = this.particleDeathAge
        particle.center = center
         
        
        if (this.positionStyle == 'cube')
            particle.position = this.randomVector3( this.positionBase, this.positionSpread ); 
        if (this.positionStyle == 'sphere')
        {
            /* var z = 2 * Math.random() - 1    
            var t = Math.PI * 2 * Math.random();
            var r = Math.sqrt( 1 - z*z ) ;
            var vec3 = new THREE.Vector3( r * Math.cos(t), r * Math.sin(t), z );
            particle.position = new THREE.Vector3().addVectors( this.positionBase, vec3.multiplyScalar( this.radius ) );
           */
            //怎么改半径
            let y = 2 * Math.random() - 1    
            let t = Math.PI * 2 * Math.random();
            let r = Math.sqrt( 1 - y*y ) ; //因为 r*r = 1-y*y = x*x + z*z = r*r(cos^2 + sin^2 );
            let lowDownRatio = 0.2 //压低近平面
            let vec3 = new THREE.Vector3( r * Math.cos(t), y, Math.abs(r * Math.sin(t) ) * lowDownRatio);
            particle.position = new THREE.Vector3().addVectors( this.positionBase, vec3.multiplyScalar( this.radius ) );
           
          
        } 
         
        particle.position.add(center)//add
         
         
         
         
         
        if ( this.velocityStyle == 'cube' )
        {
            particle.velocity  = this.randomVector3( this.velocityBase,  this.velocitySpread ); 
        }
        if ( this.velocityStyle == 'sphere' )  
        {
            //var direction = particle.position.clone()
            var direction = new THREE.Vector3(0,0,1) //烟应该都是向上的
            var speed     = this.randomValue( this.speedBase, this.speedSpread );
            particle.velocity  = direction.normalize().multiplyScalar( speed );
        }
        
        particle.acceleration = this.randomValue( this.accelerationBase, this.accelerationSpread ); 

        particle.angle             = this.randomValue( this.angleBase,             this.angleSpread );
        particle.angleVelocity     = this.randomValue( this.angleVelocityBase,     this.angleVelocitySpread );
        particle.angleAcceleration = this.randomValue( this.angleAccelerationBase, this.angleAccelerationSpread );

        particle.size = this.randomValue( this.sizeBase, this.sizeSpread );

        var color = this.randomVector3( this.colorBase, this.colorSpread );
        particle.color = new THREE.Color().setHSL( color.x, color.y, color.z );
        
        particle.opacity = this.randomValue( this.opacityBase, this.opacitySpread );

        particle.age   = 0;
        particle.alive = 0; // particles initialize as inactive
        return particle;
    }			


    getPointsForBound(){
        return this.boundPoints; //可以用于expand实时bound的点， 不含particle的size等边距
    }

    getBound(points){ // points为生成点（圆心）
        this.boundPoints = [] 
        let boundingBox = new THREE.Box3()
        
        
        let maxSize = this.sizeTween.values.slice().sort((a,b)=>b-a)[0]            
        let margin0 = maxSize * 0.11
        let margin1 = margin0 + 0.5   ;//保守估计还会飘出这么多距离吧: size + 飘动  
        
         
        points.forEach(bottom=>{ 
            let top = bottom.clone()
            top.z +=  this.height 
            boundingBox.expandByPoint(bottom);
            boundingBox.expandByPoint(top); 
            this.boundPoints.push(bottom,top)
        })
        let xyExpand = this.radius+margin1 
        boundingBox.expandByVector(new THREE.Vector3(xyExpand,xyExpand,0))
        boundingBox.min.z -= margin0 
        boundingBox.max.z += margin1 
       
       
       
        this.boundingBox = boundingBox
        
        /* if(!this.debugBox){
            this.debugBox = new THREE.Mesh(boxGeo, boxMat)
            this.add(this.debugBox)
        }
        
        this.debugBox.scale.copy(boundingBox.getSize(new THREE.Vector3))
        this.debugBox.position.copy(boundingBox.getCenter(new THREE.Vector3))  */  
         
    }

    createGeometry(){
        this.particleArray = []
        const positions = [];
        const colors = [];
        const alives = [];
        const opacitys = [];
        const sizes = [];
        const angles = [];
               
        let count, points;
        if(this.positions.length>1){
             
            const spaceDis = 0.6;//间隔距离
            
            count = Math.ceil(this.curve.wholeLength / spaceDis) + 1 
             
            points = this.curve.getSpacedPoints( count );  
            
            count = points.length
            
            /* points.forEach(e=>  { 
                var sphere = debugSphere.clone();
                sphere.position.copy(e)
                viewer.scene.scene.add(sphere)
            }) */
            let haventGetPoints = points.slice() 
            var getRanPoints = function(i){
                var a = Math.random()
                let choseIndex = Math.floor(haventGetPoints.length * a)
                var point = haventGetPoints[choseIndex]
                if(haventGetPoints.length == 1){
                    haventGetPoints = points.slice()  
                }else{
                    haventGetPoints.splice(choseIndex, 1)
                }
                return point
            }
            
            
            this.getBound(points)
        }else{
            this.getBound(this.positions)
        }
        
        
        
        
        
        for (var i = 0; i < this.particleCount; i++)
        {
            var center = new THREE.Vector3().copy(this.positions.length>1 ? getRanPoints(i)  : this.positions[0])
             
            //var center = new THREE.Vector3().copy(this.positions.length>1 ? points[Math.floor(i/this.particleCount * count)] : this.positions[0])
              
             
            // remove duplicate code somehow, here and in update function below.
            this.particleArray[i] = this.createParticle(center);
            positions[3*i] = this.particleArray[i].position.x
            positions[3*i+1] = this.particleArray[i].position.y
            positions[3*i+2] = this.particleArray[i].position.z

            colors[3*i] = this.particleArray[i].color.r 
            colors[3*i+1] = this.particleArray[i].color.g
            colors[3*i+2] = this.particleArray[i].color.b

            alives[i] = this.particleArray[i].alive
            opacitys[i] = this.particleArray[i].opacity
            sizes[i] = this.particleArray[i].size
            angles[i] = this.particleArray[i].angle
        }

        this.geometry.setAttribute( 'position', new THREE.BufferAttribute( new Float32Array(positions), 3  ));
        this.geometry.setAttribute( 'customColor', new THREE.BufferAttribute( new Float32Array(colors), 3 ) );
        this.geometry.setAttribute( 'customVisible', new THREE.BufferAttribute( new Float32Array(alives), 1 ) );
        this.geometry.setAttribute( 'customOpacity', new THREE.BufferAttribute( new Float32Array(opacitys), 1 ) );
        this.geometry.setAttribute( 'customSize', new THREE.BufferAttribute( new Float32Array(sizes), 1 ) );
        this.geometry.setAttribute( 'customAngle', new THREE.BufferAttribute( new Float32Array(angles), 1 ) );
    }
    
    createMaterial(){
        this.material = new THREE.ShaderMaterial( 
        {
            uniforms: 
            {
                u_sampler:   { type: "t", value: getTexture() },
                heightOfNearPlane: { type: "f", value:0}  //相对far ，以确保画面缩放时点的大小也会缩放
            },
            vertexShader:   vertexShader,vertexShader,
            fragmentShader: fragmentShader,
            transparent: true,
            alphaTest: 0.5, // if having transparency issues, try including: alphaTest: 0.5, 
            blending: this.blendStyle,
            depthTest: this.blendStyle != THREE.NormalBlending
        });
        
        
        this.setPerspective(this.fov, this.screenHeight)
        
        
    }
    

    update(dt){
        if(!Potree.Utils.getObjVisiByReason(this,'force')){//被手动隐藏了
            return
        }
        if(!Potree.Utils.isInsideFrustum(this.boundingBox, viewer.scene.getActiveCamera())){
            Potree.Utils.updateVisible(this,'isInsideFrustum', false ) //不在视野范围
            //console.log('unvi')
            return
        }else{
            Potree.Utils.updateVisible(this,'isInsideFrustum', true )
        } 
        
        
        
        if(dt > 1){
            console.log('update dt>1', dt)
        }
         
        //dt *= 0.5;
        
        const recycleIndices = [];
        const recycleAges = []
        
        
        const positions = [];
        const colors = [];
        const alives = [];
        const opacitys = [];
        const sizes = [];
        const angles = [];
    
       
        
        
        
        
        for (var i = 0; i < this.particleCount; i++)
        {
            if ( this.particleArray[i].alive )
            {
                  
                if ( this.velocityStyle == 'cube' )
                {        //一定几率改变下方向
                    let ratio = Math.random()
                    if(this.particleArray[i].age - this.particleArray[i].lastChangeVage > this.particleDeathAge*ratio  ){
                        
                        this.particleArray[i].velocity = this.randomVector3( this.velocityBase, this.velocitySpread ); 
                        
                        this.particleArray[i].lastChangeVage = this.particleArray[i].age
                    }
                }else{
                    /* if(this.particleArray[i].age - this.particleArray[i].lastChangeVage > this.particleDeathAge*0.3  ){
                        if( Math.random()>0.1){//一定几率改变下方向
                            var speed  = this.randomValue( this.speedBase, this.speedSpread ); 
                            this.particleArray[i].velocity = this.randomVector3( new THREE.Vector3,   new THREE.Vector3(1,1,1) ); 
                            this.particleArray[i].velocity.normalize().multiplyScalar( speed );
                        }
                        this.particleArray[i].lastChangeVage = this.particleArray[i].age
                    } */
                    
                    
                }
                 
                
                this.particleArray[i].update(dt);

                // check if particle should expire
                // could also use: death by size<0 or alpha<0.
                if ( this.particleArray[i].age > this.particleDeathAge ) 
                {
                    this.particleArray[i].alive = 0.0;
                    recycleIndices.push(i);
                    recycleAges.push((this.particleArray[i].age - this.particleDeathAge)%(this.particleDeathAge ))
                } 
                
                
                // update particle properties in shader
                positions[3*i] = this.particleArray[i].position.x
                positions[3*i+1] = this.particleArray[i].position.y
                positions[3*i+2] = this.particleArray[i].position.z

                colors[3*i] = this.particleArray[i].color.r 
                colors[3*i+1] = this.particleArray[i].color.g
                colors[3*i+2] = this.particleArray[i].color.b

                alives[i] = this.particleArray[i].alive
                opacitys[i] = this.particleArray[i].opacity
                sizes[i] = this.particleArray[i].size
                angles[i] = this.particleArray[i].angle
            }		
        }

        // check if particle emitter is still running
        //if ( !this.emitterAlive ) return;

        this.geometry.setAttribute( 'position', new THREE.BufferAttribute( new Float32Array(positions), 3 ) );
        this.geometry.setAttribute( 'customColor', new THREE.BufferAttribute( new Float32Array(colors), 3 ) );
        this.geometry.setAttribute( 'customVisible', new THREE.BufferAttribute( new Float32Array(alives), 1 ) );
        this.geometry.setAttribute( 'customOpacity', new THREE.BufferAttribute( new Float32Array(opacitys), 1 ) );
        this.geometry.setAttribute( 'customSize', new THREE.BufferAttribute( new Float32Array(sizes), 1 ) );
        this.geometry.setAttribute( 'customAngle', new THREE.BufferAttribute( new Float32Array(angles), 1 ) );

        this.geometry.attributes.customColor.needsUpdate = true;
        this.geometry.attributes.customVisible.needsUpdate = true;
        this.geometry.attributes.customOpacity.needsUpdate = true;
        this.geometry.attributes.customSize.needsUpdate = true;
        this.geometry.attributes.customAngle.needsUpdate = true;

        // if no particles have died yet, then there are still particles to activate
        if ( this.emitterAge < this.particleDeathAge ) //开始时一个个放出来
        {
            
            let particlesPerSecond = this.particleCount / this.particleDeathAge
            // determine indices of particles to activate
            var startIndex = Math.round( particlesPerSecond * (this.emitterAge +  0) );
            var endIndex = Math.round( particlesPerSecond * (this.emitterAge + dt) );
            if  ( endIndex > this.particleCount ) 
                endIndex = this.particleCount; 
                
            for (var i = startIndex; i < endIndex; i++)
                this.particleArray[i].alive = 1.0;		
        }

        // if any particles have died while the emitter is still running, we imediately recycle them
        for (var j = 0; j < recycleIndices.length; j++)
        {
            var i = recycleIndices[j]; 
            this.particleArray[i] = this.createParticle(this.particleArray[i].center);
            this.particleArray[i].alive = 1.0; // activate right away
            this.particleArray[i].age = recycleAges[j]
            positions[3*i] = this.particleArray[i].position.x
            positions[3*i+1] = this.particleArray[i].position.y
            positions[3*i+2] = this.particleArray[i].position.z
        }
        this.geometry.setAttribute( 'position', new THREE.BufferAttribute( new Float32Array(positions), 3 ) );
        this.geometry.attributes.position.needsUpdate = true;

        // stop emitter?
        this.emitterAge += dt;
        //if ( this.emitterAge > this.emitterDeathAge )  this.emitterAlive = false;
    }

    randomValue(base, spread)
    {
        //return base + spread * (Math.random() - 0.5);
        let p = Math.random()
        return base * p + spread * (1-p)
        
    }

    randomVector3(base, spread)
    {
        var rand3 = new THREE.Vector3( Math.random() - 0.5, Math.random() - 0.5, Math.random() - 0.5 );
        return new THREE.Vector3().addVectors( base, new THREE.Vector3().multiplyVectors( spread, rand3 ) );
    }
    
    
    
    
    setSize(e){
        let viewport = e.viewport
        this.screenHeight = viewport.resolution.y
        this.setPerspective(this.fov, this.screenHeight)  
    }
    
    setFov(fov){
        this.fov = fov
        this.setPerspective(this.fov, this.screenHeight) 
    }
    
    
    setPerspective(fov, height){
        //this.uniforms.heightOfNearPlane.value = Math.abs(height / (2 * Math.tan(THREE.Math.degToRad(fov * 0.5))));
        let far = Math.abs(height / (2 * Math.tan(THREE.Math.degToRad(fov * 0.5))));
        this.material.uniforms.heightOfNearPlane.value = far 
    }
    
    dispose(){
        this.geometry.dispose();
        this.material.dispose();
        this.dispatchEvent('dispose') 
    }
}


/* 
    改进：如果有必要
    
    根据curve中分成的点，分成多个簇，每个簇掌管该部分的可见性和particle的数量。
    在camera_changed时根据远近修改每个簇的particle的数量，当然不会大于初始创建的个数。多出的随机隐藏。


 */
